import { Button } from "@thilke/ui/components/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandShortcut,
} from "@thilke/ui/components/command";
import { Input } from "@thilke/ui/components/input";
import { Panel } from "@thilke/ui/components/panel";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@thilke/ui/components/tabs";
import { AppWindowIcon, CodeIcon } from "lucide-react";

export function TabsDemo() {
  return (
    <div className="flex flex-col gap-6">
      <Tabs defaultValue="account" className="max-w-[420px]">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="account">Account</TabsTrigger>
          <TabsTrigger value="password">Password</TabsTrigger>
        </TabsList>
        <TabsContent value="account">
          <Panel position="docked" size="md" className="grid gap-3">
            <h3 className="font-medium">Account</h3>
            <Input defaultValue="Pedro Duarte" />
            <Button>Save changes</Button>
          </Panel>
        </TabsContent>
        <TabsContent value="password">
          <Panel position="docked" size="md" className="grid gap-3">
            <h3 className="font-medium">Password</h3>
            <Input type="password" />
            <Button>Save password</Button>
          </Panel>
        </TabsContent>
      </Tabs>
      <Tabs defaultValue="preview">
        <TabsList>
          <TabsTrigger value="preview">
            <AppWindowIcon /> Preview
          </TabsTrigger>
          <TabsTrigger value="code">
            <CodeIcon /> Code
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  );
}

export function CommandDemo() {
  return (
    <Command className="max-w-md rounded-lg border shadow-md">
      <CommandInput placeholder="Type a command or search..." />
      <CommandList>
        <CommandEmpty>No results found.</CommandEmpty>
        <CommandGroup heading="Suggestions">
          <CommandItem>
            Calendar<CommandShortcut>⌘K</CommandShortcut>
          </CommandItem>
          <CommandItem>Search Emoji</CommandItem>
          <CommandItem>Calculator</CommandItem>
        </CommandGroup>
      </CommandList>
    </Command>
  );
}
